import { render, staticRenderFns } from "./UninstallDialog.vue?vue&type=template&id=bb2b0e6c&scoped=true&"
import script from "./UninstallDialog.vue?vue&type=script&lang=js&"
export * from "./UninstallDialog.vue?vue&type=script&lang=js&"
import style0 from "./UninstallDialog.vue?vue&type=style&index=0&id=bb2b0e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2b0e6c",
  null
  
)

export default component.exports